<template>
  <Modal :id="'cmp-booking-questionnaire'" @cancelled="onCancelClick">
    <template slot="header">{{$t('questionnaire')}}</template>
    <template slot="body">
      <div class="ut-text-secondary" style="margin: 0px 0px 8px 0px">
        {{$t('link')}}
      </div>
      <div
        v-if="booking"
        class="ut-flex ut-jbetween"
        style="
          height: 36px;
          border: 1px solid var(--sprt-85);
          border-radius: 4px;
          padding: 5px 8px;
          align-items: center;
          margin-bottom: 8px;
        "
      >

      
        <div style="flex: 1" class="ut-link ut-text-accent5 txtov">
          <template v-if="newURL">
            {{ newURL }}
          </template>
          <template v-else>
            {{ booking["link_url"] }}
          </template>
          
        </div>
        <button
          class="dt-button v5 s8"
          style="min-width: 60px; margin-right: 0px"
          @click="onCopyLinkClick"
        >
          {{$t('copy_link')}}
        </button>
      </div>
      <SearchList
        :id="'relationTypes'"
        :items="relationTypes"
        :keyProperty="'local_details_type_id'"
        :label="'local_details_type_name'"
        :isSearchable="false"
        :disabledFunc="relationDisabled"
        :selected="selectedrelationTypes"
        @selected="onrelationTypesSelected"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick"> {{$t('cancel')}} </button>
      <button class="dt-button v1 s6" @click="onContinueClick"> {{$t('continue')}} </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";

import SearchList from "@dtplugins/search-list/search-list";
import { overviewService } from "../../services/booking-details/booking-overview.service";
import { openWindow } from "../../../../utility";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { copyToClipboard } from "../../../../dt-plugins/clipboard/clipboard";
// import { overviewService } from '../../services/booking-details/booking-overview.service';

export default {
  components: {
    SearchList,
    Modal,
  },
  props: ["booking"],
  data: function () {
    return {
      relationTypes: [],
      localDetails: [],
      searchString: "",
      selectedrelationTypes: new Set(),
    };
  },
  mounted: async function () {
    console.log(this.$route.params.calendar_date_id);
    const questionnaireData = await overviewService.getQuestionnaireData(
      this.$route.params.calendar_date_id
    );
    // const calJson = await overviewService.getCalendarDateJSON(
    //   this.$route.params.calendar_date_id
    // );
    console.log(questionnaireData.data);
    this.relationTypes = questionnaireData.data.relation_types;
    this.localDetails = questionnaireData.data.local_details;

    setTimeout(() => {
      if (this.localDetails.length > 0) {
        this.selectedrelationTypes = new Set(
          this.localDetails.map((ld) => ld.local_details_type_id)
        );
      } else {
        this.selectedrelationTypes = new Set(
          this.relationTypes.map((ld) => ld.local_details_type_id)
        );
      }
      console.log("SELECTED RELATION TYPE", this.selectedrelationTypes);
    });
  },
  computed: {
    artistId: function () {
      console.log("this.$route",this.$route)
      return this.$route.query.artist_id;
      
    },
    calendar_date_id: function () {
      return this.$route.params.calendar_date_id;
    },
    newURL:function(){
      return this.$route.query?.newURL||undefined
    }
  },
  methods: {
    onContinueClick: async function () {
     
      await overviewService.addDefaultLocalDetails(
        Array.from(this.selectedrelationTypes).join(","),
        this.calendar_date_id
      );
      this.$emit("onLoadLocalDetails",{ calendar_date_id:this.calendar_date_id  })
      openModalRoute(this, "choose_mail_template", {
        type: "questionnaire",
        newURL:this.newURL
      });

     

    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onrelationTypesSelected: function (selectedrelationTypes) {
      this.selectedrelationTypes = selectedrelationTypes;
    },
    relationDisabled: function (item) {
      // console.log(item, this.localDetails);
      if (!this.localDetails) {
        return false;
      }
      if (
        this.localDetails
          .map((e) => e.local_details_type_name)
          .includes(item.local_details_type_name)
      ) {
        return true;
      } else {
        return false;
      }
    },
    onCopyLinkClick() {
      if(this.newURL){
        copyToClipboard(this.newURL);
      }else{
        copyToClipboard(this.booking?.link_url);
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.relationTypes-container {
}
</style>
